import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import queryString from 'query-string';
import get from 'lodash/get';

import DashboardBookList from 'rebook/apps/dashboard/components/DashboardBookList';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import DashboardBookListEmpty from 'rebook/apps/dashboard/components/DashboardBookListEmpty';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import * as BooksetListActions from 'rebook/apps/catalog/actions/BooksetListActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import capitalize from 'rebook/apps/utils/text/capitalize';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class BooksetListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    const state = store.getState();
    const rubric = get(state, 'ssr.query.rubric', null);
    return store.dispatch(BooksetListActions.fetchInitialData(rubric));
  }

  constructor(props) {
    super(props);
    const { rubric } = queryString.parse(props.location.search);
    this.state = {
      rubric,
    };
  }

  componentDidUpdate(prevState) {
    const { history } = this.props;
    const { fromBookset } = this.props.booksetList;
    const { rubric } = queryString.parse(history.location.search);
    const { location, booksetList } = prevState;
    const { rubric: prevRubric } = queryString.parse(location.search);

    if (fromBookset !== booksetList.fromBookset || (rubric !== prevRubric)) {
      this.setState({ rubric });
      this.props.BooksetListActions.fetchInitialData(rubric, history.location);
    }
  }

  componentDidMount() {
    const { location } = this.props;
    const { rubric } = queryString.parse(location.search);
    this.setState({ rubric });
    this.props.BooksetListActions.fetchInitialData(rubric, location);
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  changePage(pageNumber) {
    const { rubric } = this.state;
    window.scrollTo(0, 0);
    this.props.BooksetListActions.fetchBooksets(pageNumber, rubric);
  }

  render() {
    const { pageNumber, lastPageNumber, booksets, rubricInfo, totalBookSets } = this.props.booksetList;
    const { rubric } = this.state;
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Все подборки', url:
              {
                pathname: '/sets/',
              },
            },
            { text: (rubric && get(rubricInfo, 'name', null)) || '', url: '' },
          ]} />
          <div className="sectionHeader">
            {(rubric && get(rubricInfo, 'name', null))
              ? <h1 className={styles.headerTitle}>{`Подборки по теме «${rubricInfo.name.trim()}»`}</h1>
              : <h1>Подборки редакции</h1>}
          </div>
          <div className={styles.count}>
            {totalBookSets}&nbsp;{`${pluralize(totalBookSets, 'подборка', 'подборки', 'подборок')}`}
          </div>
          {booksets
            ? (
              booksets.map((bookset) => (
                <DashboardBookList
                  key={`${bookset.id}-${bookset.slug}`}
                  picture={bookset.picture}
                  pictureName={bookset.short_name}
                  title={capitalize(bookset.name)}
                  books={bookset.books}
                  bookCount={bookset.active_book_count}
                  linkMore={bookset.absolute_url}
                  extraClassName="jest-booksetlist-item" />
              ))
            )
            : (
              [...Array(5)].map((item, i) => (
                <DashboardBookListEmpty key={i} />
              ))
            )
          }
          {lastPageNumber > 1 && (
            <ContextPagination
              extraClassName="jest-booksetlist-pagination"
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    booksetList: state.booksetList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BooksetListActions: bindActionCreators(BooksetListActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BooksetListView);
